<template>
  <div>
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="columns"
      :row-class-name="rowClassName"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:errorMsg="{ row }">
        <el-tooltip
          class="box-item"
          effect="dark"
          raw-content
          placement="top-start"
        >
          <div slot="content" v-html="row.errorMsg"></div>

          <div
            style="
            word-break: keep-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          "
          >
            {{ formatMsg(row.errorMsg) }}
          </div>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { cloneDeep } from 'lodash'

export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isError: {
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
      craftsmanshipDifficultyList: [],
      rowClassName: ({ row }) => {
        if (row.errorMsg) {
          return 'bg-danger text-white'
        }
        return ''
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 300
    },

    getData() {
      if (!this.items) {
        return []
      }
      return this.items
    },

    formatMsg(title) {
      return title?.replaceAll('<br/>', '、')
    },
  },
  computed: {
    columns() {
      const colums = tableColumns(this, this.isError)
      return colums
    },
  },
  watch: {
    items: {
      handler() {
        this.tableData = cloneDeep(this.items)
      },
      immediate: true,
    },
    columns: {
      handler() {
        const result = {}
        // 遍历并处理每个节点
        const processNode = (node) => {
          if (node.title && node.field) {
            result[node.title] = node.field // 提取 title 和 field
          }
        }
        // 遍历顶层
        this.columns.forEach(processNode)
        this.$emit('confirm', result)
      },
      immediate: true,
    },
  },
}
</script>
